import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HeaderOnboarding from '../HeaderOnboarding';
import { TabContent, TabPane, Nav, NavItem, NavLink, Collapse } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import onboardingImg from '@assets/images/onboarding1.png'
import onboardingImg2 from '@assets/images/onboarding2.png'
import onboardingImg3 from '@assets/images/onboarding3.png'
import referral1 from '@assets/images/referral1.png'
import referral2 from '@assets/images/referral2.png'
import referral3 from '@assets/images/referral3.png'
import referral4 from '@assets/images/referral4.png'
import referral5 from '@assets/images/referral5.png'
import onboardingImg4 from '@assets/images/onboarding4.png'
import zoho_faq1 from '@assets/images/zoho/zoho_faq1.png'
import zoho_faq2 from '@assets/images/zoho/zoho_faq2.png'
import zoho_faq3 from '@assets/images/zoho/zoho_faq3.png'
import zoho_faq4 from '@assets/images/zoho/zoho_faq4.png'
import cleverTap from '../../services/cleverTap';


class FaqsPage extends React.Component{
    constructor(props) {
        super(props);
        if (this.props.activeTab) {
            const tab4 = {
                tabId: 4,
                name: 'Referrals Related',
                data: [7, 8, 9, 17, 21, 22, 23, 24, 25, 26, 27],
                msg: 'Faq_referral_selected',
                category: 'referral'
            }

            const accIndex = tab4.data[tab4.data.length - 1];
            this.toggle(tab4);
            this.state.openAccordianIndex = accIndex;
            location.href = '#faqs' + (accIndex - 1);
        }
    }

    state = {
        openAccordianIndex: -1,
        activeTab: this.props.activeTab || 1,
    }

    onViewIncentivePlan = () => {
      window.location.replace(window.location.origin + '/app/dashboard/web/incentives/my-plan')
    }
    
  labels = ['What is PayUmoney Partner Program?',
    'Who can become a PayUmoney Partner?',
    'What benefits will I get as a Partner?',
    'How do I become a PayUmoney Partner and refer a Client?',
    'I have a merchant account with PayUmoney. Can I use the same account to refer my clients?',
    'I haven’t registered my company yet. Can I sign up as a PayUmoney Partner?',
    'What documents will be required to register as a PayUmoney Partner?',
    'What will be the Sign-up process for my clients?',
    'Can I register on behalf of my client?',
    'How to track the status of my referrals?',
    'How will PayUmoney process the Partner commission?',
    'What will be the payout cycle of the commission amount?',
    'Will I get a dedicated account manager for support?',
    'Will I be getting help for Integration?',
    'What if I want some other plan from what is being offered by PayU?',
    'What if I do not submit my profile details but keep referring merchants to PayU?',
    'How can I learn about my Incentives?',
    'How can I refer a merchant from the partner portal?',
    'How do I raise an Invoice for the Incentives I earned?',
    'What if my partner profile details are rejected by PayU?',
    'I disagreed to the agreement accidentally? How can I rejoin to the PayU Partner Program?',
    'How do I monitor my Clients performance?',
    'How can I know what happened to a referral I made?',
    'How do I get to know a summary of my Referrals so far?',
    'How can I search for a particular merchant’s details from the My Referrals list?',
    'What are the search filter options that I can apply on my referrals list?',
    'What are the meaning of the various onboarding statuses on my referrals page?',
    'Where can I find my Merchant ID, Key & Salt details?'
  ]
  data = {
    0:(
      <React.Fragment>
        A program that enables you to integrate the best payment gateway technology for your clients and in
        process build trust & credibility for your business.
        This is backed by a lucrative referral and commission plan.
      </React.Fragment>
    ),
    1:(
      <React.Fragment>
        Practically anyone from a student to an e-commerce consultant can partner with us! List of some of the probable partners are:
        <ul>
          <li><strong>Web Developers and Designers</strong></li>
          <li><strong>Web Developers and Designers</strong></li>
          <li><strong>Digital Marketing Agencies</strong></li>
          <li><strong>Bloggers</strong></li>
          <li><strong>Students & Freelancers</strong></li>
          <li><strong>E-commerce Consultants</strong></li>
          <li><strong>Individuals</strong></li>
        </ul>
      </React.Fragment>
    ),
    2:(
      <React.Fragment>
        By partnering with PayUmoney, you will get an opportunity to build trust and credibility for your business and grow financially with lucrative commission plans
        The details of your incentives plan are available in the <Link to="/dashboard/web/incentives/my-plan" onClick={this.onViewIncentivePlan}>My Incentives Plan</Link> page of your partner dashboard.<br/>
        Note:
        <ul>
          <li>You receive incentives only after completing your profile and once agreement is closed with PayUmoney</li>
          <li>You receive incentives only if you have at least Rs. 100 as incentive based on the plans mentioned above.</li>
          <li>The incentives will be processed quarterly.</li>
        </ul>
      </React.Fragment>
    ),
    3:(
      <React.Fragment>
        A. You can become a PayUmoney partner in 3 easy steps.
        <ul>
          <li>Go to <Link to="/">PayUmoney Partner Program</Link> page.</li>
	        <li>Click on <strong>Create Account</strong>. And then enter your email Id and mobile number</li><br/>
          <img src={onboardingImg} alt="onboarding-icon"  width="700" height="400" />
          <li>You will receive an OTP on your email & mobile which are to be verified.</li>
        </ul>
        B. Once verified, you will be <strong>logged</strong> into the Partner dashboard .Then click on <strong>Add Merchant</strong> option to start referring.<br/><br/>
          <img src={onboardingImg2} alt="onboarding2-icon"  width="700" height="400" />
        <br/><br/>
        C. At any time of your choice you have to complete the Reseller Profile details so that your agreement may be generated.
          You will not be eligible for incentives until the agreement is generated and then accepted by you.
          A screen shot of the reseller profile details screen is shown below.
          <br/><br/>
        <img src={onboardingImg3} alt="onboarding3-icon"  width="700" height="400" />
        <br/><br/>
        You will not be allowed to refer more than 50 merchants to PayU unless your profile details are completed. Once profile is submitted, the scanned copy of your PAN Card, Address Proof and Cancelled Check should be emailed to reseller.admin@payu.in.

      </React.Fragment>
    ),
    4:(
      <React.Fragment>
        Unfortunately, that is not possible. You will have to create a separate Partner account with us.
      </React.Fragment>
    ),
    5:(
      <React.Fragment>
        Yes, please select <strong>‘Individual’</strong> as Business category when you do not have a registered company while submitting your profile details.<br/><br/>
        <img src={onboardingImg4} alt="onboarding4-icon"  width="700" height="500" />
      </React.Fragment>
    ),
    6:(
      <React.Fragment>
        You will have to email the signed soft copies of the following documents
        <ul>
          <li>Pancard</li>
          <li>Address Proof</li>
          <li>Cancelled Cheque</li>
        </ul>
        To the Email: reseller.admin@payu.in<br/>
        Address: 9th Floor, Bestech Business Tower, Sohna Road, Sector-48, Gurgaon-122002, Haryana, India.<br/>
        We will verify your bank details using these documents & process the incentives in your bank account.
      </React.Fragment>
    ),
    7:(
      <React.Fragment>
        The Sign-up process for your clients remains exactly the same as any normal PayUmoney merchant.
      </React.Fragment>

    ),
    8:(
      <React.Fragment>
        Yes, you can submit all information on behalf of your client directly from your Partner dashboard. Then your client will have to review & verify the details submitted by you.
      </React.Fragment>
    ),
    9:(
      <React.Fragment>
        You can get real time status of your referrals on the <Link to= "/">PayUmoney Partner dashboard</Link>. Here, you can track their status under ‘Status’ column.<br/><br/>
        <img src={onboardingImg2} alt="onboarding2-icon"  width="700" height="400" />
      </React.Fragment>
    ),
    10:(
      <React.Fragment>
        We process incentives on a quarterly basis
        <ul>
	        <li>Every month, we will calculate incentives based on your plan and inform you about the same over email. (We will soon start notifying you on the dashboard too)</li>
	        <li>You are required to raise an Invoice to us for the Incentive amount.</li>
	        <li>Your incentive will be processed into your bank account within 30 days post you submit an undisputed invoice</li>
        </ul>
      </React.Fragment>
    ),
    11:(
      <React.Fragment>
        We will payout the incentives you earned on a quarterly basis.
      </React.Fragment>
    ),
    12:(
      <React.Fragment>
        Yes, we will provide a dedicated account manager who will help you with on all aspects of your partnership with PayU.
      </React.Fragment>
    ),
    13:(
      <React.Fragment>
        Yes, for your assistance we have ready to use integration kits available on the <a href="https://developer.payumoney.com"> PayUmoney developer guide</a>.
        In case, you still need more help, you can reach our tech support <a href=" https://www.payumoney.com/contact-us.html?userType=seller"> here</a>.
      </React.Fragment>
    ),
    14:(
      <React.Fragment>
        We can look at customizing the plans on the basis of leads expected and transaction volume from your clients. For that, you will have to:
	      <ul>
          <li>Register for <strong>PayUmoney Partner Program</strong></li>
	        <li>Write to us at <Link to="">reseller.admin@payu.in</Link> from your Partner Email ID</li>
        </ul>
      </React.Fragment>
    ),
    15:(
      <React.Fragment>
        In order to simplify the onboarding process for you, we allow you to refer as many as 50 merchants
        to us without submitting your profile. However, you will not be eligible for any incentives
        until you submit your profile and then subsequently accept your agreement.
        However, once you accept the agreement, incentives will be shared with you
        retrospectively on the next billing cycle.
      </React.Fragment>
    ),
    16:(
      <React.Fragment>
        PayU will share with you a termly Invoice on your registered email id on a quarterly basis. The Invoice will contain details regarding the breakup of incentives.
      </React.Fragment>
    ),

    17:(
      <React.Fragment>
        <ul>
       	  <li>Login to the partner dashboard</li>
           <img src={onboardingImg2} alt="onboarding2-icon"  width="700" height="400" /><br/><br/>
          <li>Click on <strong>Add Merchant</strong> CTA. The following popup opens up.</li>
          <img src={referral2} alt="referral2-icon"  width="700" height="400" /><br/><br/>
          <li>Enter the email id, mobile number & name of the merchant being referred.</li>
          <img src={referral1} alt="referral1-icon"  width="700" height="400" /><br/><br/>
          <li>You are required to select the PayU Pricing Plan that you offered to your client in the next form as shown below.</li>
          <img src={referral4} alt="referral4-icon"  width="700" height="400" /><br/><br/>
          <li>Optionally enter the merchant profile details like merchant address, bank account information etc.
              Partial filling of profile details is not allowed in the second form.</li>
          <img src={referral3} alt="referral3-icon"  width="700" height="400" /><br/><br/>
          <li>Click on Submit. You will receive a success referral notification.</li>
          <img src={referral5} alt="referral5-icon"  width="700" height="400" /><br/><br/>
        </ul>
      </React.Fragment>
    ),
    18:(
      <React.Fragment>
        PayU will share with you the details about your incentives on your registered email id on a
        termly basis. You are required to raise an Invoice for the amount mentioned to PayU to be
        shared over email to <Link to="">partner.support@payu.in</Link>. The Invoices are to be sent to PayU from
        your registered email id with the subject: Invoice – Month Name- Profile Name.
        Eg: Invoice – January- Prashant C. You will receive the money in your bank account within
        30 days of sharing undisputed invoice.
      </React.Fragment>
    ),
    19:(
      <React.Fragment>
        PayU allows you to re-submit your profile details from the partner dashboard.
        Once Profile is rejected, your profile details will be editable again. But you will no longer
        be able to refer any new merchants to PayU or claim any incentives for your existing
        referrals till your profile details are verified again by our team.
      </React.Fragment>
    ),
    20:(
      <React.Fragment>
        In case you declined the agreement, you are not eligible for incentives under the PayU
        partner program. You will also be blocked from referring any new merchants to PayU in the future.
        But if you declined the agreement by mistake you may write to us at partner.support@payu.in.
        We will help you in getting your existing PayU partner account reactivated.
      </React.Fragment>
    ),
    21:(
      <React.Fragment>
        All the clients your referred are listed on your partner dashboard.
        You can see the net settlements received by your Client on your partner dashboard under
        the ‘Merchant’s Settlement’ field.
      </React.Fragment>
    ),
    22:(
      <React.Fragment>
        All the clients your referred are listed on your partner dashboard. The status field on your
        reseller dashboard home gives you information about where your merchant is with respect
        to PayU onboarding process.
      </React.Fragment>
    ),
    23:(
      <React.Fragment>
        On your partner dashboard, we give you the following information:<br/>
         &nbsp;<strong>Referred Merchants</strong>: The total number of successful referrals made by you.<br/>
         &nbsp;<strong>Live Merchants</strong>: The total number of merchants whom you have referred and have successfully completed PayU onboarding.<br/>
         &nbsp;<strong>Merchant Settlements</strong>: The cumulative total amount received by all your merchants as the settlement.<br/>
      </React.Fragment>
    ),
    24:(
      <React.Fragment>
        On the search bar on the top left corner of the My Referrals tab, you will be able to search for a merchant using ‘Merchant Id, Merchant Email & Merchant Mobile Number’.
      </React.Fragment>
    ),
    25:(
      <React.Fragment>
        You can apply a filter your referral’s list by using the following search filters<br/>
        &nbsp;a. <strong>Filter by status</strong>: Filters merchant based on the merchant onboarding status with PayU. The different statuses are Account Created, Profile Submitted, Bank verified, Documents Upload in progress, Document Verification in Progress, Documents Rejected, Website Verification in Progress & Live.<br/>
        &nbsp;b. <strong>Filter by product</strong>: Allows you to filter merchants based on whether the referral was for PayUbiz or PayUmoney.<br/>
        &nbsp;c. <strong>Settlement Amount Range</strong>: Allows you to filter your referrals based on their performance. The filter will be applied based on the total settlement they have received to their bank account so far.<br/>
        The number of filters applied is reflected in the search icon for your reference.
      </React.Fragment>
    ),
    26:(
      <React.Fragment>
        <strong>Account Created</strong>: A PayUmoney account has been created with email, mobile & merchant name. No other merchant profile details have been submitted yet.<br/>
 
        <strong>Profile Submitted</strong>: The merchant profile details like Address, Business Registration information, Bank details etc. has been submitted by or on behalf of the merchant. But the bank account details are not verified yet.<br/>
         
        <strong>Bank verified</strong>: Bank account of the merchant has been verified either by using penny verification or other means, but the merchant is yet to start with the upload of the documents required by PayUmoney.<br/>
         
        <strong>Documents Upload In Progress</strong>: This status means that the merchant has started with the documents upload process but is yet to complete the same.<br/>
         
        <strong>Documents Verification In Progress</strong>: This status implies that the merchant has successfully completed the upload of all documents required by PayU, but the verification by PayU is in progress.<br/>
         
        <strong>Documents Rejected</strong>: This status implies that the documents submitted by the merchants were incorrect and hence PayU have rejected the same. The merchant may re-upload the right documents on the merchant dashboard.<br/>
         
        <strong>Website Verification in Progress</strong>: This is a generic status that implies that the merchant’s website details have not been successfully verified yet by PayU. There is no separate status available on partner dashboard even if PayU has rejected the website details submitted, though detailed information is available to the merchant on the merchant dashboard. Please note that if the website verification is successfully completed by PayU before documents are successfully verified then a reseller will not see this status.<br/>
         
        <strong>Live</strong>: This means the merchant is successfully on-boarded to PayU and can receive settlements in his bank account.

      </React.Fragment>
    ),
    27:(
        <React.Fragment>
            <div>
                To find your merchant ID:
                <ol>
                    <li>Navigate to ‘Profile’ tab on top right corner of PayU dashboard</li>
                    <img src={zoho_faq1} alt="onboarding2-icon"  width="700" height="400" /><br/><br/>
                    <li>Go to ‘General Details’ and you will be able to locate your Merchant ID</li>
                    <img src={zoho_faq2} alt="referral2-icon"  width="700" height="400" /><br/><br/>
                </ol>

                To find your Key & Salt Details:
                <ol>
                    <li>Navigate to 'Settings’ tab on top right corner of PayU dashboard</li>
                    <img src={zoho_faq3} alt="onboarding2-icon"  width="700" height="400" /><br/><br/>
                    <li>Go to ‘Integration Details’</li>
                    <img src={zoho_faq4} alt="referral2-icon"  width="700" height="400" /><br/><br/>
                </ol>
            </div>
        </React.Fragment>

    )
  }

  toggle(tab) {
    if (this.state.activeTab !== tab.tabId) {
      cleverTap.event(tab.msg);
      this.setState({
          activeTab: tab.tabId
      });
    }
  }

  renderAccordians(accordians, category, data) {
    const accordionData = Object.values(accordians).map((v) => {
      return (
        { index: v, label: this.labels[v], data: this.data[v] }
      );
    })
    return accordionData.map((accordian) => {
      const isAccordianOpen = this.state.openAccordianIndex === accordian.index;
      const divId = 'faqs' + accordian.index;
      return (
        <div className={`faq-accordian-container ${isAccordianOpen ? 'open-accordion': ''}`} id={divId}>
          <h4 className="accordian-heading pl-3" onClick={this.toggleAccordian(accordian.index,category,data)}>
            {accordian.label}
            {isAccordianOpen ? <span className="circle right float-right close-btn ">x</span> :
            <span className="circle right float-right open">+</span>}
          </h4>
          <Collapse isOpen={isAccordianOpen}>
            <div className="faq-accordion-data" >{accordian.data}</div>
          </Collapse>
        </div>
      );
    });
  }
  toggleAccordian = (toggleTab,category,data) => () => {
    if (this.state.openAccordianIndex !== toggleTab) {
      const question_number = data.indexOf(toggleTab)
      cleverTap.event(`faq_${category}_${question_number + 1}_read`)
      this.setState({
        openAccordianIndex: toggleTab,
      });
    } else {
      this.setState({ openAccordianIndex: -1 });
    }
  }

  renderTabData(tabs){
    return tabs.map((tab) => {
      return (
        <div className="onboarding-layout">
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId={tab.tabId}>
              {React.Children.toArray(this.renderAccordians(tab.data, tab.category, tab.data))}
            </TabPane>
          </TabContent>
        </div>
      )
    })
  }

  renderTabs(tabs){
    return tabs.map((tab) => {
      return (
        <div>
            <NavItem>
              <NavLink
                className ={classnames({ active: this.state.activeTab === tab.tabId })}
                onClick={() => { this.toggle(tab); }}>
                {tab.name}
              </NavLink>
            </NavItem>
        </div>
      )
    })
  }
  render(){
    const tabData = {
      GENERAL:{
        tabId: 1,
        name: 'General Questions',
        data: [0, 1, 12, 13],
        msg: 'Faq_general_selected',
        category: 'general'
      },
      INCENTIVES:{
        tabId: 2,
        name: 'Incentives Related',
        data: [2, 10, 11, 14, 16, 18],
        msg: 'Faq_incentives_selected',
        category: 'incentives'
      },
      ONBOARDING:{
        tabId: 3,
        name: 'Onboarding Related',
        data: [3, 4, 5, 6, 15, 19, 20],
        msg: 'Faq_onboarding_selected',
        category: 'onboarding'
      },
      REFERRAL:{
        tabId: 4,
        name: 'Referrals Related',
        data: [7, 8, 9, 17, 21, 22, 23, 24, 25, 26, 27],
        msg: 'Faq_referral_selected',
        category: 'referral'
      }
    }
    return(

      <div>
        <HeaderOnboarding pageTitle = 'Faq'/>
        <div className="profile-setting-container faq-page">
          <div className="main-body mt-100">
          <Nav tabs>
          {React.Children.toArray(this.renderTabs(Object.values(tabData)))}
          </Nav>
          {React.Children.toArray(this.renderTabData(Object.values(tabData)))}
          </div>
      </div>
    </div>
    )
  }
}
export default FaqsPage